// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"simwefpayback","52":"simbudgetrechner","210":"simpension2024","257":"simiv","332":"widgetvaus","525":"simtodesfall25","670":"simeinkaufpot","688":"standalonebeitragsrechner","810":"simwef","849":"simeinkauf","914":"preload","918":"simtodesfall","978":"simhypo","994":"simbeitrag"}[chunkId] + ".css";
};